var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('avue-data-box',{attrs:{"option":_vm.icons}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"25%","display":"inline-block"},attrs:{"id":"c2"}}),_c('div',{staticStyle:{"width":"50%","display":"inline-block"},attrs:{"id":"c1"}}),_c('div',{staticStyle:{"width":"25%","display":"inline-block"},attrs:{"id":"c0"}})])
}]

export { render, staticRenderFns }